import request from '@/utils/request'

// ======================== Auth ========================

export function adminLogin(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

// ======================== Dashboard ========================

export function getDashboard() {
  return request({
    url: '/admin/dashboard',
    method: 'get'
  })
}

// ======================== Users ========================

export function getUsers(params) {
  return request({
    url: '/admin/users',
    method: 'get',
    params
  })
}

export function getUserDetail(id) {
  return request({
    url: `/admin/user/${id}`,
    method: 'get'
  })
}

export function updateWechatPopup(userId, disabled) {
  return request({
    url: `/admin/user/${userId}/wechat-popup`,
    method: 'put',
    data: { disabled }
  })
}

export function updateParentBookingWechatPopup(userId, disabled) {
  return request({
    url: `/admin/user/${userId}/parent-booking-wechat-popup`,
    method: 'put',
    data: { disabled }
  })
}

export function updateWechatBinding(userId, added) {
  return request({
    url: `/admin/user/${userId}/wechat-binding`,
    method: 'put',
    data: { added }
  })
}

// ======================== Teachers ========================

export function getTeachers(params) {
  return request({
    url: '/admin/teachers',
    method: 'get',
    params
  })
}

export function addTeacher(data) {
  return request({
    url: '/admin/teacher',
    method: 'post',
    data
  })
}

export function updateTeacher(data) {
  return request({
    url: '/admin/teacher',
    method: 'put',
    data
  })
}

export function deleteTeacher(id) {
  return request({
    url: `/admin/teacher/${id}`,
    method: 'delete'
  })
}

export function addTeacherTimeSlot(data) {
  return request({
    url: '/admin/teacher/slot',
    method: 'post',
    data
  })
}

export function getTeacherCalendar(teacherId, params) {
  return request({
    url: `/admin/teacher/${teacherId}/calendar`,
    method: 'get',
    params
  })
}

export function getTeacherAvailableSlots(teacherId, params) {
  return request({
    url: `/admin/teacher/${teacherId}/available-slots`,
    method: 'get',
    params
  })
}

export function updateTeacherTimeSlot(data) {
  return request({
    url: '/admin/teacher/slot',
    method: 'put',
    data
  })
}

export function deleteTeacherTimeSlot(id) {
  return request({
    url: `/admin/teacher/slot/${id}`,
    method: 'delete'
  })
}

// ======================== Trial Permissions ========================

export function getTrialPermissions(params) {
  return request({
    url: '/admin/trial-permissions',
    method: 'get',
    params
  })
}

// ======================== Trial Bookings ========================

export function getTrialBookings(params) {
  return request({
    url: '/admin/trial-bookings',
    method: 'get',
    params
  })
}

export function confirmTrialBooking(id, data) {
  return request({
    url: `/admin/trial-bookings/${id}/confirm`,
    method: 'put',
    data
  })
}

export function rejectTrialBooking(id, data) {
  return request({
    url: `/admin/trial-bookings/${id}/reject`,
    method: 'put',
    data
  })
}

// ======================== Class Hours ========================

export function getClassHours(params) {
  return request({
    url: '/admin/class-hours',
    method: 'get',
    params
  })
}

export function updateClassHour(id, data) {
  return request({
    url: `/admin/class-hours/${id}`,
    method: 'put',
    data
  })
}

// ======================== Formal Bookings ========================

export function getFormalBookings(params) {
  return request({
    url: '/admin/formal-bookings',
    method: 'get',
    params
  })
}

export function confirmFormalBooking(id, data) {
  return request({
    url: `/admin/formal-bookings/${id}/confirm`,
    method: 'put',
    data
  })
}

export function rejectFormalBooking(id, data) {
  return request({
    url: `/admin/formal-bookings/${id}/reject`,
    method: 'put',
    data
  })
}

// ======================== Course Level Packages ========================

export function getCourseLevelPackageGroups(params) {
  return request({
    url: '/admin/course-level-package-groups',
    method: 'get',
    params
  })
}

export function getCourseLevelPackageGroup(params) {
  return request({
    url: '/admin/course-level-package-group',
    method: 'get',
    params
  })
}

export function getCourseLevelPackageAvailableSubjects(params) {
  return request({
    url: '/admin/course-level-package-available-subjects',
    method: 'get',
    params
  })
}

export function saveCourseLevelPackageGroup(data) {
  return request({
    url: '/admin/course-level-package-group',
    method: 'post',
    data
  })
}

export function deleteCourseLevelPackageGroup(params) {
  return request({
    url: '/admin/course-level-package-group',
    method: 'delete',
    params
  })
}

export function getCourseLevelPackages(params) {
  return request({
    url: '/admin/course-level-packages',
    method: 'get',
    params
  })
}

export function saveCourseLevelPackage(data) {
  return request({
    url: '/admin/course-level-package',
    method: 'post',
    data
  })
}

export function deleteCourseLevelPackage(id) {
  return request({
    url: `/admin/course-level-package/${id}`,
    method: 'delete'
  })
}

// ======================== Homepage Teachers ========================

export function getHomepageTeachers(params) {
  return request({
    url: '/admin/homepage-teachers',
    method: 'get',
    params
  })
}

export function getHomepageTeacherDetail(id) {
  return request({
    url: `/admin/homepage-teachers/${id}`,
    method: 'get'
  })
}

export function saveHomepageTeacher(data) {
  return request({
    url: '/admin/homepage-teacher',
    method: 'post',
    data
  })
}

export function deleteHomepageTeacher(id) {
  return request({
    url: `/admin/homepage-teacher/${id}`,
    method: 'delete'
  })
}

// ======================== Orders ========================

export function getOrders(params) {
  return request({
    url: '/admin/orders',
    method: 'get',
    params
  })
}

export function createOrder(data) {
  return request({
    url: '/admin/orders',
    method: 'post',
    data
  })
}

export function getOrderDetail(id) {
  return request({
    url: `/admin/orders/${id}`,
    method: 'get'
  })
}

export function deleteOrder(id) {
  return request({
    url: `/admin/orders/${id}`,
    method: 'delete'
  })
}

export function setOrderClassHourDisabled(id, disabled) {
  return request({
    url: `/admin/orders/${id}/class-hour-disabled`,
    method: 'put',
    data: { disabled }
  })
}

export function getBookingTeachers(params) {
  return request({
    url: '/course/booking-teachers',
    method: 'get',
    params
  })
}

export function getLevelPackages(params) {
  return request({
    url: '/course/level-packages',
    method: 'get',
    params
  })
}

// ======================== Refunds ========================

export function getRefunds(params) {
  return request({
    url: '/admin/refunds',
    method: 'get',
    params
  })
}

export function processRefund(id, data) {
  return request({
    url: `/admin/refund/${id}/process`,
    method: 'post',
    data
  })
}

export function syncAlipayRefund(id) {
  return request({
    url: `/admin/refund/${id}/sync-alipay`,
    method: 'post'
  })
}

export function syncAlipayPay(orderId) {
  return request({
    url: `/admin/order/${orderId}/sync-alipay-pay`,
    method: 'post'
  })
}

// ======================== Agents ========================

export function getAgents(params) {
  return request({
    url: '/admin/agents',
    method: 'get',
    params
  })
}

export function getAgentDetail(id) {
  return request({
    url: `/admin/agent/${id}`,
    method: 'get'
  })
}

export function addAgent(data) {
  return request({
    url: '/admin/agent',
    method: 'post',
    data
  })
}

export function updateAgentBank(id, data) {
  return request({
    url: `/admin/agent/${id}/bank`,
    method: 'put',
    data
  })
}

export function getAgentMaterialList(params) {
  return request({
    url: '/admin/agent-materials/list',
    method: 'get',
    params
  })
}

export function addAgentMaterial(data) {
  return request({
    url: '/admin/agent-materials',
    method: 'post',
    data
  })
}

export function updateAgentMaterial(id, data) {
  return request({
    url: `/admin/agent-materials/${id}`,
    method: 'put',
    data
  })
}

export function deleteAgentMaterial(id) {
  return request({
    url: `/admin/agent-materials/${id}`,
    method: 'delete'
  })
}

// ======================== Withdrawals ========================

export function getWithdrawals(params) {
  return request({
    url: '/admin/withdrawals',
    method: 'get',
    params
  })
}

export function approveWithdrawal(id) {
  return request({
    url: `/admin/withdrawal/${id}/approve`,
    method: 'post'
  })
}

export function rejectWithdrawal(id, data) {
  return request({
    url: `/admin/withdrawal/${id}/reject`,
    method: 'post',
    data
  })
}

// ======================== Commissions ========================

export function getCommissions(params) {
  return request({
    url: '/admin/commissions',
    method: 'get',
    params
  })
}

// ======================== Operation Logs ========================

export function getOperationLogs(params) {
  return request({
    url: '/admin/logs',
    method: 'get',
    params
  })
}

// ======================== Course Packages ========================

export function getCoursePackages(params) {
  return request({
    url: '/admin/course-packages',
    method: 'get',
    params
  })
}

export function addCoursePackage(data) {
  return request({
    url: '/admin/course-package',
    method: 'post',
    data
  })
}

export function updateCoursePackage(data) {
  return request({
    url: '/admin/course-package',
    method: 'put',
    data
  })
}

export function deleteCoursePackage(id) {
  return request({
    url: `/admin/course-package/${id}`,
    method: 'delete'
  })
}

// ======================== Config Management ========================

// 广告位管理
export function getAdBannerList(params) {
  return request({
    url: '/admin/ad-banners/list',
    method: 'get',
    params
  })
}

export function addAdBanner(data) {
  return request({
    url: '/admin/ad-banners',
    method: 'post',
    data
  })
}

export function updateAdBanner(id, data) {
  return request({
    url: `/admin/ad-banners/${id}`,
    method: 'put',
    data
  })
}

export function deleteAdBanner(id) {
  return request({
    url: `/admin/ad-banners/${id}`,
    method: 'delete'
  })
}

// 滚动消息管理
export function getScrollMessageList(params) {
  return request({
    url: '/admin/scroll-messages/list',
    method: 'get',
    params
  })
}

export function addScrollMessage(data) {
  return request({
    url: '/admin/scroll-messages',
    method: 'post',
    data
  })
}

export function updateScrollMessage(id, data) {
  return request({
    url: `/admin/scroll-messages/${id}`,
    method: 'put',
    data
  })
}

export function deleteScrollMessage(id) {
  return request({
    url: `/admin/scroll-messages/${id}`,
    method: 'delete'
  })
}

// 官网在线咨询
export function getConsultationList(params) {
  return request({
    url: '/admin/consultations/list',
    method: 'get',
    params
  })
}

export function getConsultationDetail(id) {
  return request({
    url: `/admin/consultations/${id}`,
    method: 'get'
  })
}

// 科目管理
export function getSubjectList() {
  return request({
    url: '/admin/subjects/list',
    method: 'get'
  })
}

export function addSubject(data) {
  return request({
    url: '/admin/subjects',
    method: 'post',
    data
  })
}

export function updateSubject(id, data) {
  return request({
    url: `/admin/subjects/${id}`,
    method: 'put',
    data
  })
}

export function deleteSubject(id) {
  return request({
    url: `/admin/subjects/${id}`,
    method: 'delete'
  })
}

// 年级管理
export function getGradeList() {
  return request({
    url: '/admin/grades/list',
    method: 'get'
  })
}

export function addGrade(data) {
  return request({
    url: '/admin/grades',
    method: 'post',
    data
  })
}

export function updateGrade(id, data) {
  return request({
    url: `/admin/grades/${id}`,
    method: 'put',
    data
  })
}

export function deleteGrade(id) {
  return request({
    url: `/admin/grades/${id}`,
    method: 'delete'
  })
}

// 学校管理
export function getSchoolList() {
  return request({
    url: '/admin/schools/list',
    method: 'get'
  })
}

export function addSchool(data) {
  return request({
    url: '/admin/schools',
    method: 'post',
    data
  })
}

export function updateSchool(id, data) {
  return request({
    url: `/admin/schools/${id}`,
    method: 'put',
    data
  })
}

export function deleteSchool(id) {
  return request({
    url: `/admin/schools/${id}`,
    method: 'delete'
  })
}

// 年级科目映射
export function getGradeSubjectMappings(params) {
  return request({
    url: '/admin/grade-subject-mappings/list',
    method: 'get',
    params
  })
}

export function batchSaveGradeSubjectMappings(data) {
  return request({
    url: '/admin/grade-subject-mappings/batch-save',
    method: 'post',
    data
  })
}

// 时间段管理
export function getTimeSlotList() {
  return request({
    url: '/admin/time-slots/list',
    method: 'get'
  })
}

export function addTimeSlot(data) {
  return request({
    url: '/admin/time-slots',
    method: 'post',
    data
  })
}

export function updateTimeSlot(id, data) {
  return request({
    url: `/admin/time-slots/${id}`,
    method: 'put',
    data
  })
}

export function deleteTimeSlot(id) {
  return request({
    url: `/admin/time-slots/${id}`,
    method: 'delete'
  })
}

// 试听权益管理
export function getTrialBenefitList() {
  return request({
    url: '/admin/trial-benefits/list',
    method: 'get'
  })
}

export function addTrialBenefit(data) {
  return request({
    url: '/admin/trial-benefits',
    method: 'post',
    data
  })
}

export function updateTrialBenefit(id, data) {
  return request({
    url: `/admin/trial-benefits/${id}`,
    method: 'put',
    data
  })
}

export function deleteTrialBenefit(id) {
  return request({
    url: `/admin/trial-benefits/${id}`,
    method: 'delete'
  })
}

// 首页文案管理
export function getHomeSectionTextList() {
  return request({
    url: '/admin/home-section-texts/list',
    method: 'get'
  })
}

export function updateHomeSectionText(id, data) {
  return request({
    url: `/admin/home-section-texts/${id}`,
    method: 'put',
    data
  })
}

// 通用配置管理
export function getSiteConfigs(params) {
  return request({
    url: '/admin/site-configs',
    method: 'get',
    params
  })
}

export function saveSiteConfigs(data) {
  return request({
    url: '/admin/site-configs',
    method: 'put',
    data
  })
}

// 客服配置
export function getCustomerServiceConfig() {
  return request({
    url: '/admin/customer-service-config',
    method: 'get'
  })
}

export function saveCustomerServiceConfig(data) {
  return request({
    url: '/admin/customer-service-config',
    method: 'put',
    data
  })
}

// ======================== Recordings ========================

export function getRecordings(params) {
  return request({
    url: '/admin/recordings',
    method: 'get',
    params
  })
}

export function getRecordingDetail(id) {
  return request({
    url: `/admin/recording/${id}`,
    method: 'get'
  })
}
